// Push alert utilities (browser Notification API, no server infra needed).

const STORE_KEY = "pantau_alerts_v1";
const NOTIFIED_KEY = "pantau_alerts_notified";

export const DEFAULT_ALERT_SETTINGS = {
  enabled: false,
  quakeMinMag: 6.0,
  volcanoAwas: true,
  fireMinFrp: 100,
};

export function loadAlertSettings() {
  try {
    const raw = localStorage.getItem(STORE_KEY);
    if (!raw) return { ...DEFAULT_ALERT_SETTINGS };
    return { ...DEFAULT_ALERT_SETTINGS, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULT_ALERT_SETTINGS };
  }
}

export function saveAlertSettings(s) {
  localStorage.setItem(STORE_KEY, JSON.stringify(s));
}

export async function requestNotificationPermission() {
  if (!("Notification" in window)) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  const p = await Notification.requestPermission();
  return p;
}

function loadNotified() {
  try { return new Set(JSON.parse(sessionStorage.getItem(NOTIFIED_KEY) || "[]")); }
  catch { return new Set(); }
}

function saveNotified(set) {
  const arr = [...set].slice(-500);
  sessionStorage.setItem(NOTIFIED_KEY, JSON.stringify(arr));
}

function send(title, body, tag) {
  if (typeof Notification === "undefined" || Notification.permission !== "granted") return;
  try {
    new Notification(title, { body, tag, icon: "/favicon.ico" });
  } catch (e) { console.warn("notif failed:", e); }
}

export function evaluateAlerts({ settings, quakes, volcanoes, fires }) {
  if (!settings?.enabled) return;
  if (typeof Notification === "undefined" || Notification.permission !== "granted") return;
  const notified = loadNotified();

  // Earthquakes ≥ threshold
  (quakes || []).forEach((q) => {
    if (q.magnitude >= settings.quakeMinMag) {
      const key = `q:${q.id}`;
      if (!notified.has(key)) {
        send(`⚠ Gempa M ${q.magnitude.toFixed(1)}`, `${q.location} · Depth ${q.depth?.toFixed(0)} km`, key);
        notified.add(key);
      }
    }
  });

  // Volcanoes Awas (alertLevel === 4)
  if (settings.volcanoAwas) {
    (volcanoes || []).forEach((v) => {
      if (v.alertLevel >= 4) {
        const key = `v:${v.id}:${v.alertLevel}`;
        if (!notified.has(key)) {
          send(`🔺 Gunung Api Awas: ${v.name}`, `${v.country} · Level ${v.alertLevel} (Awas)`, key);
          notified.add(key);
        }
      }
    });
  }

  // Fire clusters ≥ threshold FRP
  (fires || []).forEach((f) => {
    if ((f.frp || 0) >= settings.fireMinFrp) {
      const key = `f:${f.id}`;
      if (!notified.has(key)) {
        send(`🔥 Karhutla FRP ${f.frp} MW`, `${f.instrument} · ${f.confidence?.toUpperCase()} · ${f.latitude.toFixed(2)},${f.longitude.toFixed(2)}`, key);
        notified.add(key);
      }
    }
  });

  saveNotified(notified);
}
